export const tasksDrugstoresListTableStructure = {
    massActions: [
        {
            text: "Usuń",
            icon: "fas fa-trash-alt",
            action: "delete",
            class: "btn btn-danger mass-operations-btn",
            enabled: true,
        },
    ],
    headers: {
        centralId: {
            text: "KamsfotId",
            key: "drugstoreClientId",
            type: "text",
            sortable: false,
            style: "cursor:pointer;width:10%",
        },
        name: {
            text: "Nazwa",
            key: "name",
            type: "text",
            sortable: false,
            style: "cursor:pointer;width:60%",
        }, // available types: number, string, date,datetime,array,boolean,actions,button
        actions: {
            text: "Akcje",
            key: "actions",
            type: "actions",
            style: "cursor:pointer;width:30%",
            visible: true,
            actions: [
                {
                    text: "Usuń",
                    icon: "trash-alt",
                    action: "delete",
                    class: "btn btn-danger table-actions-button edit-button",
                    enabled: true,
                },
            ],
        },
    },
    data: [],
};
